module.exports = __webpack_public_path__ + "504eb9fab0737b96fa3fe2b9767752ea.pdf";